export enum ApiFeedItemStatus {
  new = 'new',
  inProgress = 'inProgress',
  rejected = 'rejected',
  waitingOnExternalDependency = 'waitingOnExternalDependency',
  completed = 'completed',
  deleted = 'deleted',
  submitted = 'submitted',
  confirmed = 'confirmed',
}

export enum ApiFeedItemType {
  achRequirement = 'achRequirement',
  identityVerification = 'identityVerification',
  titleVerification = 'titleVerification',
  utilityBill = 'utilityBill',
  lightReachWelcomeQuestionnaire = 'lightReachWelcomeQuestionnaire',
  signContract = 'signContract',
  protectedClassConfirmation = 'protectedClassConfirmation',
  utilityBillRequirement = 'utilityBillRequirement',
  lightReachHVACSignOff = 'lightReachHVACSignOff',
  hvacLightreachWelcomeQuestionnaire = 'hvacLightreachWelcomeQuestionnaire',
  lightReachEnergyBackupSignOff = 'lightReachEnergyBackupSignOff',
  creditQualificationRequirement = 'creditQualificationRequirement',
  waterHeaterLightreachWelcomeQuestionnaire = 'waterHeaterLightreachWelcomeQuestionnaire',
  lightReachWaterHeaterSignOff = 'lightReachWaterHeaterSignOff',
  geothermalHeatPumpLightreachWelcomeQuestionnaire = 'geothermalHeatPumpLightreachWelcomeQuestionnaire',
  lightReachGeothermalHeatPumpSignOff = 'lightReachGeothermalHeatPumpSignOff',
  generatorLightreachWelcomeQuestionnaire = 'generatorLightreachWelcomeQuestionnaire',
  lightReachGeneratorSignOff = 'lightReachGeneratorSignOff',
  kycMismatch = 'kycMismatch',
  welcomeCall = 'welcomeCall',
  energyPlanEducation = 'energyPlanEducation',
  comfortPlanHvacEducation = 'comfortPlanHvacEducation',
  billingEducation = 'billingEducation',
  seasonalityEducation = 'seasonalityEducation',
  lightEnergyEnrollment = 'lightEnergyEnrollment',
}

export type FeedItemRewardTypes = 'giftCard';

export interface FeedItemReward {
  type: FeedItemRewardTypes;
  value?: number | string;
}

export interface ApiFeedItem {
  _id: string;
  userId?: string;
  projectId?: string;
  type?: ApiFeedItemType;
  status?: ApiFeedItemStatus;
  ctaUrl?: string;
  ctaType?: ApiCtaType;
  statusHistory?: ApiFeedItemStatusHistory[];
  customItem?: ApiCustomFeedItem;
  displayParams?: FeedItemDisplayParams;
  rewards?: FeedItemReward[];
}

export enum ApiCustomFeedItem {
  noActionableItems = 'noActionableItems',
}

export interface FeedItemDisplayParams {
  [key: string]: string | number | boolean | Date | (string | number | boolean | Date)[];
}

export interface ApiFeedItemStatusHistory {
  status: ApiFeedItemStatus;
  updatedAt: Date;
}

export enum ApiCtaType {
  openUrl = 'openUrl',
  openExternalUrl = 'openExternalUrl',
  documentUpload = 'documentUpload',
}

export interface ApiFeedItemTypeDocument {
  type: ApiFeedItemType;
  ranking: number;
  ctaUrl?: string;
  ctaType?: ApiCtaType;
}
